exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ts_dlg_header\r\n{\r\n\tbackground-color: #004895;\r\n\tfont-size:122%;\r\n\theight:40px;\r\n\tpadding:8px 0px 0px 0px;\r\n}\r\n\r\n.ts_dlg_title\r\n{\r\n\tcolor:White;\r\n\tdisplay:inline;\r\n\tfont-weight:bold;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/usc-store/usc-attachment-lookup/usc-attachment-lookup.component.css
// module id = ../../../../../src/app/components/usc-store/usc-attachment-lookup/usc-attachment-lookup.component.css
// module chunks = main